const ACCEPTABLE_FORMATS = ["svg", "png", "jpg", "webp","jpeg"];

function replaceURLWithCDN(
    url: string,
    width?: number | string,
    height?: string,
    quality?: number | string,
): string {
    try {
        // For absolute URLs, use the URL API to properly set/replace query params
        const u = new URL(url);
        const ext = u.pathname.split(".").pop() ?? "";
        if (ACCEPTABLE_FORMATS.includes(ext)) {
            u.searchParams.set("format", "webp");
        }
        if (width) u.searchParams.set("width", String(width));
        if (height) u.searchParams.set("height", String(height));
        if (quality) u.searchParams.set("quality", String(quality));
        return u.toString();
    } catch {
        // Relative URL — fall back to string appending
        const ext = url.split(".").pop() ?? "";
        if (ACCEPTABLE_FORMATS.includes(ext)) {
            url = `${url}?format=webp`;
        }
        if (width) url = `${url}&width=${width}`;
        if (height) url = `${url}&height=${height}`;
        if (quality) url = `${url}&quality=${quality}`;
        return url;
    }
}

export function customImageLoader({
    src,
    width,
    quality,
}: {
    src: string;
    width: number;
    quality?: number;
}) {
    // Next passes `quality` through to the loader, but it was previously
    // dropped here — callers like GoogleAd's quality={75} had no effect on
    // the actual CDN request until this was forwarded.
    return replaceURLWithCDN(src, width, undefined, quality);
}
